import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import "@/index.css";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ErrorBoundary from "@/components/ErrorBoundary";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import MenuPage from "@/pages/MenuPage";
import Contact from "@/pages/Contact";
import Galeri from "@/pages/Galeri";
import Promo from "@/pages/Promo";
import Testimoni from "@/pages/Testimoni";
import Artikel from "@/pages/Artikel";
import Faq from "@/pages/Faq";
import Tentang from "@/pages/Tentang";
import { GoogleAnalytics } from "@/lib/analytics";
import PageViewTracker from "@/lib/PageViewTracker";

function SmoothScroll() {
    useEffect(() => {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches)
            return undefined;
        const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
        };
    }, []);
    return null;
}

function App() {
    return (
        <ErrorBoundary>
            <BrowserRouter>
                <SmoothScroll />
                <GoogleAnalytics />
                <PageViewTracker />
                <ScrollToTop />
                <div className="min-h-screen bg-bg font-body text-ink">
                    <Navbar />
                    <main data-testid="app-main">
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/menu" element={<MenuPage />} />
                            <Route path="/galeri" element={<Galeri />} />
                            <Route path="/promo" element={<Promo />} />
                            <Route path="/testimoni" element={<Testimoni />} />
                            <Route path="/artikel" element={<Artikel />} />
                            <Route path="/faq" element={<Faq />} />
                            <Route path="/tentang" element={<Tentang />} />
                            <Route path="/kontak" element={<Contact />} />
                            <Route path="*" element={<Home />} />
                        </Routes>
                    </main>
                    <Footer />
                </div>
            </BrowserRouter>
        </ErrorBoundary>
    );
}

export default App;